import { AcceptStatus } from '@/shared/ui/VInventAccentStatus/model/types'
import type { SubscriptionScheduleLike } from './types'

const WEEKDAY_SHORT: Record<number, string> = {
  1: 'Пн',
  2: 'Вт',
  3: 'Ср',
  4: 'Чт',
  5: 'Пт',
  6: 'Сб',
  7: 'Вс',
}

/**
 * Человекочитаемый список статусов смены (как в селектах, через AcceptStatus).
 *
 * @param statuses коды статусов
 * @param separator разделитель в итоговой строке
 */
export function formatStatusTriggersDisplay(statuses: string[] | undefined | null, separator = ', '): string {
  if (!Array.isArray(statuses) || !statuses.length) return '—'
  return statuses
    .map((raw) => {
      const code = String(raw).trim().toUpperCase()
      const meta = AcceptStatus[code as keyof typeof AcceptStatus]
      return meta?.name ?? raw
    })
    .join(separator)
}

/** Определить тип расписания, по умолчанию `interval`. */
function scheduleTypeOf(s: SubscriptionScheduleLike): string {
  const t = s.schedule_type ?? s.type
  return typeof t === 'string' && t ? t : 'interval'
}

/**
 * Расписание подписки для таблиц (профиль / роли).
 *
 * @param schedule структура расписания подписки
 */
export function formatSubscriptionScheduleDisplay(schedule: SubscriptionScheduleLike | undefined | null): string {
  if (!schedule || typeof schedule !== 'object') return '—'
  const t = scheduleTypeOf(schedule)

  switch (t) {
    case 'instant':
      return 'Сразу'
    case 'interval': {
      const minutes = Number(schedule?.interval_minutes)
      const m = Number.isFinite(minutes) && minutes > 0 ? minutes : 5
      return `Интервал: каждые ${m} мин`
    }
    case 'daily': {
      const time = schedule?.at_time?.trim()
      return time ? `Ежедневно в ${time}` : 'Ежедневно'
    }
    case 'weekly': {
      const days = (schedule?.weekdays ?? [])
        .map((d) => WEEKDAY_SHORT[Number(d)] ?? String(d))
        .filter(Boolean)
      const time = schedule?.at_time?.trim()
      const timePart = time ? ` в ${time}` : ''
      return days.length ? `Еженедельно: ${days.join(', ')}${timePart}` : `Еженедельно${timePart}`
    }
    case 'monthly': {
      const day = Number(schedule?.month_day)
      const d = Number.isFinite(day) && day >= 1 && day <= 31 ? day : 1
      const time = schedule?.at_time?.trim()
      const timePart = time ? ` в ${time}` : ''
      return `Ежемесячно: ${d}-е число${timePart}`
    }
    default:
      return t
  }
}

export * from './types'
